<div class="content-header">Authorizers</div>
<div class="header-helper">
  These are the authorizers notified to approve the change request.
</div>

<div class="content content-with-elevation">
  <div class="grid-x" *ngFor="let authorizer of authorizers">
      <div class="cell large-4 small-12 medium-6">
        <lib-user-link [user]="authorizer.user"></lib-user-link>
        <span class="header-helper" style="margin-left: 8px">{{authorizer.user.email}}</span>
      </div>
      <div class="cell large-1 medium-0 small-0"></div>
      <div class="cell large-5 small-12 medium-6">
        {{getStatus(authorizer.status)}}
      </div>


      <div class="cell large-2 small-12 medium-6 align-end" *ngIf="isContactConfirmationProcess() &&
      (authorizer.status  === 'NOOP' && !userInterFace)">
        <button class="iana-button" style="margin: 0" (click)="navigateToAuthorizeRequestPage(authorizer)">
          Authorize
        </button>
      </div>
  </div>
</div>
